import React from 'react';
import { Box, Grid, Paper, Container, Avatar } from '@mui/material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import Typo from './Typo';
import { useTranslation } from 'react-i18next';

const Testimonials = ({
  title,
}) => {
  const { t } = useTranslation();

  const testimonials = [
    {
      quote: t('testimonial1Quote'),
      author: t('testimonial1Author'),
      company: t('testimonial1Company'),
      logo: '/assets/chekup/testimonial-logo1.png',
    },
    {
      quote: t('testimonial2Quote'),
      author: t('testimonial2Author'),
      company: t('testimonial2Company'),
      logo: '/assets/chekup/testimonial-logo2.png',
    },
    {
      quote: t('testimonial3Quote'),
      author: t('testimonial3Author'),
      company: t('testimonial3Company'),
      logo: '/assets/chekup/testimonial-logo3.png',
    },
  ];

  return (
    <Container maxWidth={false}
      sx={{
        maxWidth: '1440px',
        px: { xs: 2, md: 4 },
        mt: 10,
        mb: 10,
      }}>
      <Typo
        variant="h2"
        text={title || t('testimonialsTitle')}
        sx={{
          textAlign: 'center',
          mb: 2,
        }}
      />

      <Typo
        variant="body1"
        text={t('testimonialsSubtitle')}
        sx={{
          textAlign: 'center',
          maxWidth: '800px',
          mx: 'auto',
          mb: 6,
        }}
      />

      <Grid container spacing={4} justifyContent="center" sx={{ px: { xs: 5, md: 0 } }}>
        {testimonials?.map((testimonial, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Paper
              elevation={0}
              sx={{
                p: 4,
                borderRadius: '12px',
                height: '100%',
                backgroundColor: 'white',
                border: '2px dashed rgba(188, 12, 12, 0.2)',
                position: 'relative',
                overflow: 'hidden',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0px 8px 20px rgba(0,0,0,0.08)',
                },
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: '10px',
                  left: '16px',
                  color: 'rgba(188, 12, 12, 0.08)',
                  transform: 'scale(2)',
                  transformOrigin: 'top left',
                }}
              >
                <FormatQuoteIcon fontSize="large" />
              </Box>

              <Typo
                variant="body1"
                text={testimonial.quote}
                sx={{
                  fontStyle: 'italic',
                  mb: 3,
                  position: 'relative',
                  zIndex: 1,
                  pt: 3,
                  minHeight: '100px',
                }}
              />



            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container >
  );
};

export default Testimonials;
